<div mat-dialog-title class="search-detail__header">
  <div class="search-detail__header-text">
    <div *ngFor="let data of dj3DetailData.searchResponse?.data">
      <ng-container *ngIf="recordType === 'INDIVIDUAL'; else corporateName">
        <p *ngIf="data.attributes?.nameDetails">
          {{data.attributes?.nameDetails?.primaryName?.firstName}}
          {{data.attributes?.nameDetails?.primaryName?.middleName}}
          {{data.attributes?.nameDetails?.primaryName?.surname}}
          <span class="search-detail__sub-heading">
            (#{{ dj3DetailData.uniqueReferenceCode }})
          </span>
        </p>
      </ng-container>
      <ng-template #corporateName>
        <p *ngIf="data.attributes?.nameDetails">
          {{data.attributes?.nameDetails?.primaryName?.name}} {{data.attributes?.nameDetails?.primaryName?.suffix}}
          <span class="search-detail__sub-heading">
            (#{{ dj3DetailData.uniqueReferenceCode }})
          </span>
        </p>
      </ng-template>
    </div>
  </div>

  <div class="search-detail__close" (click)="closeDialog()">
    <img class="themified-white-icon search-detail__close-icon" src="/assets/icons/cross-icon.png" />
  </div>
</div>

<div mat-dialog-content class="search-detail__content">
  <!-- LAST REVIEW DATE -->
  <div class="search-detail__column" *ngIf="isShowSection.isShowLastReviewDay">
    <div class="search-detail__title">
      LAST REVIEW DATE
    </div>
    <div class="search-detail__text">
      <div class="search-detail__item">
        <div *ngFor="let data of dj3DetailData.searchResponse?.data">
          <ng-container *ngIf="data.attributes.assetType === 'watchlist' && data.attributes.lastReviewedDate">
            <span class="search-detail__item-header">Watchlist:</span>
            {{simpleDateFormat(data.attributes?.lastReviewedDate)}}
          </ng-container>
          <ng-container *ngIf="data.attributes.assetType === 'adverse_media_entity' && data.attributes.lastReviewedDate">
            <span class="search-detail__item-header">Adverse Media:</span>
            {{simpleDateFormat(data.attributes?.lastReviewedDate)}}
          </ng-container>
          <ng-container *ngIf="data.attributes.assetType === 'state_owned_company' && data.attributes.lastReviewedDate">
            <span class="search-detail__item-header">State Owned Company:</span>
            {{simpleDateFormat(data.attributes?.lastReviewedDate)}}
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- PRIMARY NAME -->
  <div class="search-detail__column" *ngIf="isShowSection.isPrimary">
    <div class="search-detail__title">
      PRIMARY NAME
    </div>
    <div class="search-detail__text">
      <div class="search-detail__item">
        <div *ngFor="let data of dj3DetailData.searchResponse?.data">
          <ng-container *ngIf="data.attributes.nameDetails">
            <p class="search-detail__item-text">
              <span class="search-detail__item-header">Primary Name:</span>
              <ng-container *ngIf="recordType === 'INDIVIDUAL'; else isCorporate">
                {{data.attributes.nameDetails.primaryName?.firstName}} {{data.attributes.nameDetails.primaryName?.middleName}} {{data.attributes.nameDetails.primaryName?.surname}}
              </ng-container>
              <ng-template #isCorporate>
                {{ data.attributes.nameDetails.primaryName.name }}
              </ng-template>
            </p>
            <ng-container *ngIf="data.attributes.nameDetails.primaryName.associatedNames && data.attributes.nameDetails.primaryName.associatedNames.originalScriptNames">
              <ng-container *ngFor="let original of data.attributes.nameDetails.primaryName.associatedNames.originalScriptNames">
                <p class="search-detail__item-text">
                  <span class="search-detail__item-header">Original Script Names:</span>
                  {{ original.name }}
                </p>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- Spelling Variations -->
  <div class="search-detail__column" *ngIf="isShowSection.isSpellingVariations">
    <div class="search-detail__title">
      SPELLING VARIATIONS
    </div>
    <div class="search-detail__text">
      <div class="search-detail__item-header search-detail__item_md12">
        Name
      </div>
      <ng-container *ngFor="let data of dj3DetailData.searchResponse?.data">
        <ng-container *ngIf="data.attributes.nameDetails && data.attributes.nameDetails.primaryName.associatedNames.spellingVariations">
          <ng-container *ngFor="let spellingVariation of data.attributes.nameDetails.primaryName.associatedNames.spellingVariations">
            <div  class="search-detail__item search-detail__item_md12">
              <ng-container *ngIf="recordType === 'INDIVIDUAL'; else isSpellingCorporate">
                {{ spellingVariation.firstName }} {{ spellingVariation.middleName }} {{ spellingVariation.surname }}
              </ng-container>
              <ng-template #isSpellingCorporate>
                {{ spellingVariation.name }}
              </ng-template>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- ALSO KNOWN AS -->
  <div class="search-detail__column" *ngIf="isShowSection.isShowAlsoKnownAs">
    <div class="search-detail__title">
      ALSO KNOWN AS
    </div>
    <div class="search-detail__text">
      <ng-container>
        <div class="search-detail__item-header search-detail__item_md12">
          Name
        </div>
      </ng-container>
      <ng-container *ngFor="let data of dj3DetailData.searchResponse?.data">
        <ng-container *ngIf="recordType === 'INDIVIDUAL'; else corporateAlsoKnowAs">
          <ng-container *ngFor="let alsoKnownAs of data?.attributes?.nameDetails?.alsoKnownAs">
            <div class="search-detail__item search-detail__item_md12" *ngIf="alsoKnownAs">
              <div>
                {{alsoKnownAs.firstName}}
                {{alsoKnownAs.middleName}}
                {{alsoKnownAs.surname}}
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-template #corporateAlsoKnowAs>
          <div class="search-detail__item search-detail__item_md12"
            *ngIf="data.attributes.nameDetails && data.attributes.nameDetails.alsoKnownAs && data.attributes.nameDetails.alsoKnownAs.length > 0">
            <ng-container *ngFor="let item of data.attributes.nameDetails.alsoKnownAs">
              <div>{{item.name}} {{item.suffix}}</div>
            </ng-container>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>

    <!-- RISKS -->
    <div class="search-detail__column" *ngIf="isShowSection.isRisks">
      <div class="search-detail__title">
        RISKS
      </div>
      <div class="search-detail__text">
        <ng-container *ngFor="let data of dj3DetailData.searchResponse?.data">
          <ng-container *ngIf="recordType === 'INDIVIDUAL'; else corporateRisk">
            <ng-container *ngIf="data.attributes.assetType === 'person' && data.attributes.iconHints">
              <div class="search-detail__item search-detail__item_md3">
                <ul class="dj3-detail__list" *ngFor="let item of data.attributes.iconHints">
                  <li>{{item}}</li>
                </ul>
              </div>
            </ng-container>
          </ng-container>
          <ng-template #corporateRisk>
            <ng-container *ngIf="data.attributes.assetType === 'entity' && data.attributes.iconHints">
              <div class="search-detail__item search-detail__item_md3">
                <ul class="dj3-detail__list" *ngFor="let item of data.attributes.iconHints">
                  <li>{{item}}</li>
                </ul>
              </div>
            </ng-container>
          </ng-template>
        </ng-container>
      </div>
    </div>

  <!-- COUNTRY DETAILs -->
  <div class="search-detail__column" *ngIf="isShowSection.isShowCountryDetails">
    <div class="search-detail__title">
      COUNTRY DETAILS
    </div>
    <div class="search-detail__text">
      <div class="search-detail__item">
        <div *ngFor="let data of dj3DetailData.searchResponse?.data">
          <ng-container *ngIf="recordType === 'INDIVIDUAL'; else corporateCountryDetail">
            <p class="search-detail__item-text" *ngIf="data.attributes?.countryTerritoryDetails?.residence">
              <span class="search-detail__item-header">Residence:</span>
              {{data.attributes?.countryTerritoryDetails?.residence[0].descriptor ?
              data.attributes?.countryTerritoryDetails?.residence[0].descriptor : '-'}}
            </p>
            <p class="search-detail__item-text" *ngIf="data.attributes?.countryTerritoryDetails?.citizenship">
              <span class="search-detail__item-header">Citizenship:</span>
              {{data.attributes?.countryTerritoryDetails?.citizenship[0].descriptor ?
              data.attributes?.countryTerritoryDetails?.citizenship[0].descriptor : '-'}}
            </p>
            <p class="search-detail__item-text" *ngIf="data.attributes?.countryTerritoryDetails?.jurisdiction">
              <span class="search-detail__item-header">Jurisdiction:</span>
              {{data.attributes?.countryTerritoryDetails?.jurisdiction[0].descriptor ?
              data.attributes?.countryTerritoryDetails?.jurisdiction[0].descriptor : '-'}}
            </p>
          </ng-container>
          <ng-template #corporateCountryDetail>
            <p class="search-detail__item-text" *ngIf="data.attributes?.countryTerritoryDetails?.affiliation">
              <span class="search-detail__item-header">Affiliation:</span>
              {{data.attributes?.countryTerritoryDetails?.affiliation[0].descriptor ?
              data.attributes?.countryTerritoryDetails?.affiliation[0].descriptor : '-'}}
            </p>
            <p class="search-detail__item-text" *ngIf="data.attributes?.countryTerritoryDetails?.registration">
              <span class="search-detail__item-header">Registration:</span>
              {{data.attributes?.countryTerritoryDetails?.registration[0].descriptor ?
              data.attributes?.countryTerritoryDetails?.registration[0].descriptor : '-'}}
            </p>
            <p class="search-detail__item-text" *ngIf="data.attributes?.countryTerritoryDetails?.currentOwnership">
              <span class="search-detail__item-header">Current Ownership:</span>
              {{data.attributes?.countryTerritoryDetails?.currentOwnership[0].descriptor ?
              data.attributes?.countryTerritoryDetails?.currentOwnership[0].descriptor : '-'}}
            </p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- ADDRESS DETAILS -->
  <div class="search-detail__column" *ngIf="isShowSection.isShowAddressDetails">
    <div class="search-detail__title">
      ADDRESS DETAILS
    </div>
    <div class="search-detail__text">
      <ng-container>
        <div class="search-detail__item-header search-detail__item_md3">
          Address
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          Region
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          City
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          Country
        </div>
      </ng-container>
      <ng-container *ngFor="let data of dj3DetailData.searchResponse?.data">
        <ng-container *ngFor="let addressDetails of data.attributes?.addressDetails">
          <div class="search-detail__item search-detail__item_md3">
            {{addressDetails?.address ? addressDetails?.address : '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md3">
            {{addressDetails?.region ? addressDetails?.region : '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md3">
            {{addressDetails?.city ? addressDetails?.city : '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md3">
            {{addressDetails?.countryTerritory?.descriptor ? addressDetails?.countryTerritory?.descriptor : '-'}}
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- WATCHLIST -->
  <div class="search-detail__column" *ngIf="isShowSection.isShowWatchList">
    <div class="search-detail__title">
      WATCHLIST
    </div>
    <div class="search-detail__text">
      <ng-container>
        <div class="search-detail__item-header search-detail__item_md6">
          Status
        </div>
        <div class="search-detail__item-header search-detail__item_md6">
          Description
        </div>
      </ng-container>
      <ng-container *ngFor="let data of dj3DetailData.searchResponse.data">
        <ng-container *ngIf="data.attributes.contentTypeDetails">
          <ng-container *ngIf="data.attributes.contentTypeDetails.activeStatus">
            <div class="search-detail__item search-detail__item_md6">
              {{data?.attributes?.contentTypeDetails?.activeStatus ? data?.attributes?.contentTypeDetails?.activeStatus
              : '-'}}
            </div>
          </ng-container>
          <ng-container
            *ngIf="data.attributes.contentTypeDetails.contentTypes && data.attributes.contentTypeDetails.contentTypes.length > 0">
            <div class="search-detail__item search-detail__item_md6">
              {{ getDescription(data.attributes.contentTypeDetails.contentTypes) }}
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- List Reference -->
  <div class="search-detail__column" *ngIf="isShowSection.isListReference">
    <div class="search-detail__title">
      List Reference
    </div>
    <div class="search-detail__text">
      <ng-container>
        <div class="search-detail__item-header search-detail__item_md4">
          Name
        </div>
        <div class="search-detail__item-header search-detail__item_md4">
          Source
        </div>
        <div class="search-detail__item-header search-detail__item_md4">
          From Date
        </div>
      </ng-container>
      <ng-container *ngFor="let data of dj3DetailData.searchResponse?.data">
        <ng-container *ngFor="let sanction of data.attributes.sanctionsLists">
          <div class="search-detail__item search-detail__item_md4">
            {{sanction.name ? sanction.name : '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md4">
            <ng-container *ngIf="sanction.sources; else emptySources">
              <ng-container *ngFor="let source of sanction.sources">
                <a class="link search-detail__item-header link_underline" [href]="source" target="_blank" *ngIf="source">
                {{source}}
              </a>
              </ng-container>
            </ng-container>
            <ng-template #emptySources>-</ng-template>
          </div>
          <div class="search-detail__item search-detail__item_md4">
            <ng-container *ngIf="sanction.fromDate; else emptyFromDate">
              {{sanction.fromDate.day ? sanction?.fromDate.day : '-'}}/{{sanction?.fromDate.month ? sanction?.fromDate.month
              : '-'}}/{{sanction?.fromDate.year ? sanction?.fromDate.year : '-'}}
            </ng-container>
            <ng-template #emptyFromDate>-</ng-template>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- ADVERSE MEDIA -->
  <div class="search-detail__column" *ngIf="isAdverseMediaEntity(dj3DetailData.searchResponse.data) && isShowSection.isAdverseMediaDetails">
    <div class="search-detail__column">
      <div class="search-detail__title">
        ADVERSE MEDIA
      </div>
      <!-- contentTypeDetails -->
      <div *ngIf="isExistContentTypeDetails(dj3DetailData.searchResponse.data)" class="search-detail__text">
        <ng-container>
          <div class="search-detail__item-header search-detail__item_md6">Status</div>
          <div class="search-detail__item-header search-detail__item_md6">Description</div>
        </ng-container>
        <ng-container *ngFor="let data of dj3DetailData.searchResponse.data">
          <ng-container *ngIf="data.attributes.contentTypeDetails">
            <ng-container *ngIf="data.attributes.contentTypeDetails.activeStatus">
              <div class="search-detail__item search-detail__item_md6">
              {{ data.attributes.contentTypeDetails.activeStatus }}
              </div>
            </ng-container>
            <ng-container *ngIf="data.attributes.contentTypeDetails.contentTypes && data.attributes.contentTypeDetails.contentTypes.length > 0">
              <div class="search-detail__item search-detail__item_md6">
                {{ getDescription(data.attributes.contentTypeDetails.contentTypes) }}
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
      <!-- adverseMediaDetails -->
      <div class="search-detail__text">
        <ng-container *ngFor="let item of dj3DetailData.searchResponse.data">
          <ng-container *ngIf="item.attributes.adverseMediaDetails">
            <ng-container *ngFor="let adverseMediaDetail of item.attributes.adverseMediaDetails">
              <ng-container *ngFor="let itemAdverseMedia of adverseMediaDetail | keyvalue">
                <div class="search-detail__item search-detail__item_md12"
                  *ngIf="isArray(itemAdverseMedia.value); else isNotArray">
                  <ng-container *ngFor="let item of itemAdverseMedia.value">
                    <ng-container *ngFor="let element of item | keyvalue">
                      <ng-container *ngIf="isArray(element.value); else emptyData">
                        <ng-container *ngFor="let ele of element.value | keyvalue">
                          <ng-container *ngFor="let e of ele.value | keyvalue">
                            <div class="search-detail__item search-detail__item_md12">
                              <span class="search-detail__item-name">{{e.key}}</span>
                              <span class="search-detail__item-text">{{e.value}}</span>
                            </div>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <ng-template #emptyData>
                        <div class="search-detail__item search-detail__item_md12">
                          <span class="search-detail__item-name">{{element.key}}</span>
                          <span class="search-detail__item-text">{{element.value}}</span>
                        </div>
                      </ng-template>
                    </ng-container>
                  </ng-container>
                </div>
                <ng-template #isNotArray>
                  <div class="search-detail__item search-detail__item_md12">
                    <span class="search-detail__item-name">{{itemAdverseMedia.key}}</span>
                    <span class="search-detail__item-text">{{itemAdverseMedia.value}}</span>
                  </div>
                </ng-template>
              </ng-container>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="item.attributes.contentNotice">
            <div class="search-detail__item search-detail__item_md12">
              <span class="search-detail__item-name">Content Notice:</span>
              <span class="search-detail__item-text">{{item.attributes.contentNotice}}</span>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- STATE OWNED COMPANY -->
  <div class="search-detail__column" *ngIf="isShowSection.isStateOwnedCompanyDetail">
    <div class="search-detail__title">
      STATE OWNED COMPANY
    </div>
    <ng-container *ngFor="let data of dj3DetailData.searchResponse.data">
      <ng-container *ngIf="data.attributes?.assetType === 'state_owned_company' ">
        <div class="search-detail__text" *ngIf="data?.attributes?.contentTypeDetails">
          <div class="search-detail__item-header search-detail__item_md6">Status</div>
          <div class="search-detail__item-header search-detail__item_md6">Description</div>
          <div *ngIf="data.attributes.contentTypeDetails.activeStatus" class="search-detail__item_md6">
            {{ data.attributes.contentTypeDetails.activeStatus }}
          </div>
          <div
            *ngIf="data.attributes.contentTypeDetails.contentTypes && data.attributes.contentTypeDetails.contentTypes.length > 0"
            class="search-detail__item_md6">
            {{ getDescription(data.attributes.contentTypeDetails.contentTypes) }}
          </div>
        </div>
        <div class="search-detail__item search-detail__item_md12 " *ngIf="data?.attributes?.countryTerritoryDetails">
          <p class="search-detail__title search-detail__title--custom">Country Territory Details</p>
          <p *ngIf="data.attributes.countryTerritoryDetails.pastOwnership" class="search-detail__item-text">
            <span class="search-detail__item-name">Past Ownership:</span>
            <span *ngFor="let pastOwnership of data.attributes.countryTerritoryDetails.pastOwnership; let i = index">
              {{pastOwnership?.descriptor}}
              <span *ngIf="i !== ( data.attributes.countryTerritoryDetails.pastOwnership.length - 1)">, </span>
            </span>
          </p>
          <p *ngIf="data.attributes.countryTerritoryDetails.currentOwnership" class="search-detail__item-text">
            <span class="search-detail__item-name">Current Ownership:</span>
            <span
              *ngFor="let currentOwnership of data.attributes.countryTerritoryDetails.currentOwnership; let i = index">
              {{currentOwnership?.descriptor}}
              <span *ngIf="i !== ( data.attributes.countryTerritoryDetails.currentOwnership.length - 1)">,</span>
            </span>
          </p>
        </div>
        <div class="search-detail__text" *ngIf="data?.attributes?.stateOwnedCompanyDetail">
          <ng-container class="search-detail__item">
            <p class="search-detail__title search-detail__title--custom">State Owned Company Detail</p>
              <p *ngIf="data.attributes.stateOwnedCompanyDetail.votingControl" class="search-detail__item_md12 search-detail__item_md12--custom">
                <span class="search-detail__item-name">VotingControl:</span>
                {{data.attributes.stateOwnedCompanyDetail.votingControl.value}}
              </p>
            <div *ngIf="data.attributes.stateOwnedCompanyDetail.pastOwnerships" class="search-detail__item_md12 search-detail__item_md12--custom">
              <p class="search-detail__title search-detail__title--custom">Past Ownership</p>
              <p class="search-detail__item-text" *ngIf="data.attributes.stateOwnedCompanyDetail.pastOwnerships">
                <span class="search-detail__item-name">Value:</span>
                <span
                  *ngFor="let pastOwnership of data.attributes.stateOwnedCompanyDetail.pastOwnerships; let i = index">
                  {{pastOwnership.value}}
                  <span *ngIf="i !== ( data.attributes.stateOwnedCompanyDetail.pastOwnerships.length - 1)">,</span>
                </span>
              </p>
              <p class="search-detail__item-text">
                <span class="search-detail__item-name">Ownership Note:</span>
                <span
                  *ngFor="let pastOwnership of data.attributes.stateOwnedCompanyDetail.pastOwnerships; let i = index">
                  {{pastOwnership.ownershipNote}}
                  <span *ngIf="i !== ( data.attributes.stateOwnedCompanyDetail.pastOwnerships.length - 1)">,</span>
                </span>
              </p>
              <p class="search-detail__item-text">
                <span class="search-detail__item-name">Ownership Level:</span>
                <span
                  *ngFor="let pastOwnership of data.attributes.stateOwnedCompanyDetail.pastOwnerships; let i = index">
                  {{pastOwnership.ownershipLevel}}
                  <span *ngIf="i !== ( data.attributes.stateOwnedCompanyDetail.pastOwnerships.length - 1)">,</span>
                </span>
              </p>
              <p class="search-detail__item-text">
                <span class="search-detail__item-name">Government Levels:</span>
                <span
                  *ngFor="let pastOwnership of data.attributes.stateOwnedCompanyDetail.pastOwnerships; let i = index">
                  <ng-container *ngIf="pastOwnership.governmentLevels">
                    <span *ngFor="let governmentLevel of pastOwnership.governmentLevels; let a = index">
                      {{governmentLevel}}
                      <span *ngIf="a !== ( pastOwnership.governmentLevels.length - 1)">,</span>
                    </span>
                  </ng-container>
                  <span *ngIf="i !== ( data.attributes.stateOwnedCompanyDetail.pastOwnerships.length - 1)">,</span>
                </span>
              </p>
              <p class="search-detail__item-text">
                <span class="search-detail__item-name">Country Territories Of Ownership:</span>
                <span
                  *ngFor="let pastOwnership of data.attributes.stateOwnedCompanyDetail.pastOwnerships; let i = index">
                  <ng-container *ngIf="pastOwnership.countriesTerritoriesOfOwnership">
                    <span
                      *ngFor="let countriesTerritoriesOfOwnership of pastOwnership.countriesTerritoriesOfOwnership; let a = index">
                      {{countriesTerritoriesOfOwnership.descriptor}}
                      <span *ngIf="a !== ( pastOwnership.countriesTerritoriesOfOwnership.length - 1)">,</span>
                    </span>
                  </ng-container>
                  <span *ngIf="i !== ( data.attributes.stateOwnedCompanyDetail.pastOwnerships.length - 1)">,</span>
                </span>
              </p>
            </div>
            <div *ngIf="data.attributes.stateOwnedCompanyDetail.currentOwnership" class="search-detail__item_md12 search-detail__item_md12--custom">
              <p class="search-detail__title search-detail__title--custom">Current Ownership</p>
              <p *ngIf="data.attributes.stateOwnedCompanyDetail.currentOwnership.value">
                <span class="search-detail__item-name">Value:</span>
                {{data.attributes.stateOwnedCompanyDetail.currentOwnership.value}}
              </p>
              <p *ngIf="data.attributes.stateOwnedCompanyDetail.currentOwnership.ownershipNote">
                <span class="search-detail__item-name">Ownership Note: </span>
                {{data.attributes.stateOwnedCompanyDetail.currentOwnership.ownershipNote}}
              </p>
              <p *ngIf="data.attributes.stateOwnedCompanyDetail.currentOwnership.ownershipLevel">
                <span class="search-detail__item-name">Ownership Level:</span>
                {{data.attributes.stateOwnedCompanyDetail.currentOwnership.ownershipLevel}}
              </p>
              <p *ngIf="data.attributes.stateOwnedCompanyDetail.currentOwnership.governmentLevels">
                <span class="search-detail__item-name">Government Levels:</span>
                <span
                  *ngFor="let governmentLevel of data.attributes.stateOwnedCompanyDetail.currentOwnership.governmentLevels; let i = index">
                  {{governmentLevel}}
                  <span
                    *ngIf="i !== ( data.attributes.stateOwnedCompanyDetail.currentOwnership.governmentLevels.length - 1)">,
                  </span>
                </span>
              </p>
              <p *ngIf="data.attributes.stateOwnedCompanyDetail.currentOwnership.countriesTerritoriesOfOwnership">
                <span class="search-detail__item-name">Country Territories Of Ownership:</span>
                <span
                  *ngFor="let countriesTerritoriesOfOwnership of data.attributes.stateOwnedCompanyDetail.currentOwnership.countriesTerritoriesOfOwnership; let i = index">
                  {{countriesTerritoriesOfOwnership.descriptor}}
                  <span
                    *ngIf="i !== ( data.attributes.stateOwnedCompanyDetail.currentOwnership.countriesTerritoriesOfOwnership.length - 1)">,</span>
                </span>
              </p>
            </div>
            <div *ngIf="data.attributes.stateOwnedCompanyDetail.boardAppointingControl" class="search-detail__item_md12 search-detail__item_md12--custom">
              <p class="search-detail__title search-detail__title--custom">Board Appointing Control</p>
              <p class="search-detail__item-text">
                <span class="search-detail__item-name">Board Appointing Control:</span>
                {{data.attributes.stateOwnedCompanyDetail.boardAppointingControl.value}}
              </p>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <!-- PROFILE NOTES -->
  <div class="search-detail__column" *ngIf="isShowSection.isShowProfileNotes">
    <div class="search-detail__title">
      PROFILE NOTES
    </div>
    <div class="search-detail__text">
      <div *ngFor="let data of dj3DetailData.searchResponse?.data">
        <p class="search-detail__item-text search-detail__item-text-wrap"
          *ngIf="data.attributes?.commentDetails?.listComment">
          {{data.attributes?.commentDetails?.listComment}}
        </p>
        <p class="search-detail__item-text search-detail__item-text-wrap"
          *ngIf="data.attributes?.commentDetails?.siComment">
          {{data.attributes?.commentDetails?.siComment}}
        </p>
      </div>
    </div>
  </div>

  <!-- CORPORATE ADDITIONAL DETAILS - to be merged with the individual section -->
  <div class="search-detail__column" *ngIf="(recordType === 'CORPORATE') && isShowSection.isShowAdditionalDetailsCorporate">
    <div class="search-detail__title">
      ADDITIONAL DETAILS
    </div>
    <ng-container *ngFor="let data of dj3DetailData.searchResponse?.data">
      <ng-container *ngIf="data.attributes?.assetType === 'entity' " class="search-detail__item">
        <ng-container *ngIf="data.attributes.dateDetails.registration">
          <ng-container *ngFor="let item of data.attributes.dateDetails.registration">
            <p class="search-detail__item-text" >
              <span class="search-detail__item-header">Date of Registration: </span>
              {{item.date.day ? item.date.day : '-'}}/{{item.date.month
                ? item.date.month :'-'}}/{{item.date.year ? item.date.year:'-'}}
            </p>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>

  <!-- ADDITIONAL DETAILS -->
  <div class="search-detail__column" *ngIf="(recordType === 'INDIVIDUAL') && isShowSection.isShowAdditionalDetails">
    <div class="search-detail__title">
      ADDITIONAL DETAILS
    </div>
    <ng-container *ngFor="let data of dj3DetailData.searchResponse?.data">
      <ng-container *ngIf="data.attributes?.assetType === 'person' " class="search-detail__item">
        <p class="search-detail__item-text" *ngIf="data.attributes?.gender">
          <span class="search-detail__item-header">Gender: </span>
          {{data.attributes?.gender}}
        </p>
        <p class="search-detail__item-text" *ngIf="data.attributes?.isDeceased">
          <span class="search-detail__item-header">Deceased(isDeceased): </span>
          {{data.attributes?.isDeceased}}
        </p>
        <p class="search-detail__item-text" *ngIf="data.attributes?.contentSets">
          <span class="search-detail__item-header">Content Sets: </span>
          <ng-container>
            <span *ngFor="let contentSet of data.attributes?.contentSets; let i = index">
              {{contentSet}}<span *ngIf="i !== (data.attributes?.contentSets.length - 1)">, </span>
            </span>
          </ng-container>
        </p>
        <ng-container *ngIf="data.attributes?.dateDetails && data.attributes?.dateDetails.birth && data.attributes?.dateDetails.birth.length > 0">
          <ng-container *ngFor="let item of data.attributes.dateDetails.birth">
            <p class="search-detail__item-text" >
              <span class="search-detail__item-header">Date of Birth: </span>
              {{item.date.day ? item.date.day : '-'}}/{{item.date.month
                ? item.date.month :'-'}}/{{item.date.year ? item.date.year:'-'}}
            </p>
          </ng-container>
        </ng-container>
        <p class="search-detail__item-text" *ngIf="data.attributes?.dateDetails?.deceased">
          <span class="search-detail__item-header">Date Deceased: </span>
          {{data.attributes?.dateDetails?.deceased[0].date?.day ? data.attributes?.dateDetails?.deceased[0].date?.day :
          '-'}}/
          {{data.attributes?.dateDetails?.deceased[0].date?.month ?
          data.attributes?.dateDetails?.deceased[0].date?.month : '-'}}/
          {{data.attributes?.dateDetails?.deceased[0].date?.year ? data.attributes?.dateDetails?.deceased[0].date?.year
          : '-'}}
        </p>
        <p class="search-detail__item-text" *ngIf="data.attributes?.dateDetails?.inactiveAsOfDate">
          <span class="search-detail__item-header">Inactive As Of Date (PEP): </span>
          <ng-container *ngIf="data.attributes?.dateDetails?.inactiveAsOfDate.pep; else inActiveAsOfDateRCA">
            {{data.attributes?.dateDetails?.inactiveAsOfDate?.pep?.day ?
            data.attributes?.dateDetails?.inactiveAsOfDate?.pep?.day : '-'}}/{{data.attributes?.dateDetails?.inactiveAsOfDate?.pep?.month ?
            data.attributes?.dateDetails?.inactiveAsOfDate?.pep?.month : '-'}}/{{data.attributes?.dateDetails?.inactiveAsOfDate?.pep?.year ?
            data.attributes?.dateDetails?.inactiveAsOfDate?.pep?.year : '-'}}
          </ng-container>
          <ng-template #inActiveAsOfDateRCA>
            {{data.attributes?.dateDetails?.inactiveAsOfDate?.rca?.day ?
            data.attributes?.dateDetails?.inactiveAsOfDate?.rca?.day : '-'}}/
            {{data.attributes?.dateDetails?.inactiveAsOfDate?.rca?.month ?
            data.attributes?.dateDetails?.inactiveAsOfDate?.rca?.month : '-'}}/
            {{data.attributes?.dateDetails?.inactiveAsOfDate?.rca?.year ?
            data.attributes?.dateDetails?.inactiveAsOfDate?.rca?.year : '-'}}
          </ng-template>
        </p>
        <p class="search-detail__item-text" *ngIf="data.attributes?.dateDetails?.placesOfBirth">
          <span class="search-detail__item-header">Place of Birth: </span>
          <span
            *ngIf="data.attributes?.dateDetails?.placesOfBirth?.city">{{data.attributes?.dateDetails?.placesOfBirth?.region}},</span>
          <span
            *ngIf="data.attributes?.dateDetails?.placesOfBirth?.country">{{data.attributes?.dateDetails?.placesOfBirth?.country}},</span>
        </p>
        <p class="search-detail__item-text"
          *ngIf="data.attributes?.associatedEntityDetails && data.attributes?.associatedEntityDetails?.associatedEntities">
          <span class="search-detail__item-header">Company Name:</span>
          <ng-container>
            <span
              *ngFor="let associatedEntities of data.attributes?.associatedEntityDetails?.associatedEntities; let i = index">
              {{associatedEntities.companyName}}
              <span *ngIf="i !== (data.attributes?.associatedEntityDetails?.associatedEntities.length - 1)">, </span>
            </span>
          </ng-container>
        </p>
        <p class="search-detail__item-text"
          *ngIf="data.attributes?.associatedEntityDetails && data.attributes?.associatedEntityDetails?.associatedEntities">
          <span class="search-detail__item-header">Company FCode:</span>
          <ng-container>
            <span
              *ngFor="let associatedEntities of data.attributes?.associatedEntityDetails?.associatedEntities; let i = index">
              {{associatedEntities.companyFCode}}
              <span *ngIf="i !== (data.attributes?.associatedEntityDetails?.associatedEntities.length - 1)">, </span>
            </span>
          </ng-container>
        </p>
      </ng-container>
    </ng-container>
  </div>

  <!-- INDUSTRIES -->
  <div class="search-detail__column" *ngIf="(recordType === 'CORPORATE') && isShowSection.isShowIndustries">
    <div class="search-detail__title">
      INDUSTRIES
    </div>
    <div class="search-detail__text">
      <ng-container>
        <div class="search-detail__item-header search-detail__item_md4">
          Industry
        </div>
        <div class="search-detail__item-header search-detail__item_md4">
          Code
        </div>
        <div class="search-detail__item-header search-detail__item_md4">
          Description
        </div>
      </ng-container>
      <ng-container *ngFor="let data of dj3DetailData.searchResponse?.data">
        <ng-container *ngFor="let industry of data.attributes?.industries">
          <div class="search-detail__item search-detail__item_md4">
            {{industry?.descriptor ? industry?.descriptor : '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md4">
            {{industry?.code ? industry?.code : '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md4">
            {{industry?.description ? industry?.description : '-'}}
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- Identity Details -->
  <div class="search-detail__column" *ngIf="isShowSection.isShowIdentityDetails">
    <div class="search-detail__title">
      Identity Details
    </div>
    <div class="search-detail__text">
      <ng-container>
        <div class="search-detail__item-header search-detail__item_md3">
          Type
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          Id Number
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          Comments
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          Issue Date
        </div>
      </ng-container>
      <ng-container *ngFor="let data of dj3DetailData.searchResponse?.data">
        <ng-container *ngFor="let identificationDetail of data.attributes?.identificationDetails">
          <div class="search-detail__item search-detail__item_md3">
            {{identificationDetail?.type ? identificationDetail?.type : '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md3">
            {{identificationDetail?.value ? identificationDetail?.value : '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md3">
            {{identificationDetail?.comments ? identificationDetail?.comments : '-'}}
          </div>
          <div class="search-detail__item search-detail__item_md3">
            <ng-container *ngIf="identificationDetail.issueDate; else emptyIssueDate">
              {{ identificationDetail?.issueDate?.day ? identificationDetail.issueDate.day : '-'}}/{{ identificationDetail.issueDate.month ?
                identificationDetail?.issueDate?.month : '-' }}/{{ identificationDetail?.issueDate?.year ? identificationDetail?.issueDate?.year : '-' }}
            </ng-container>
            <ng-template #emptyIssueDate>
              -
            </ng-template>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- PRIMARY ROLES -->
  <div class="search-detail__column" *ngIf="(recordType === 'INDIVIDUAL') && isShowSection.isShowPrimaryRoles">
    <div class="search-detail__title">
      PRIMARY ROLES
    </div>
    <div class="search-detail__text">
      <ng-container>
        <div class="search-detail__item-header search-detail__item_md3">
          Title
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          Category Type
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          From
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          To
        </div>
      </ng-container>
      <ng-container *ngFor="let data of dj3DetailData.searchResponse?.data">
        <ng-container *ngIf="data.attributes?.assetType === 'watchlist' && data.attributes?.roleDetails?.primary">
          <ng-container>
            <div class="search-detail__item search-detail__item_md3">
              {{data.attributes?.roleDetails?.primary?.title ? data.attributes?.roleDetails?.primary?.title : '-'}}
            </div>
            <div class="search-detail__item search-detail__item_md3">
              {{data.attributes?.roleDetails?.primary?.categoryType ? data.attributes?.roleDetails?.primary?.categoryType : '-'}}
            </div>
            <div class="search-detail__item search-detail__item_md3">
              {{data.attributes?.roleDetails?.primary?.since?.day ? data.attributes?.roleDetails?.primary?.since?.day : '-'}}/{{data.attributes?.roleDetails?.primary?.since?.month ?
                data.attributes?.roleDetails?.primary?.since?.month : '-'}}/{{data.attributes?.roleDetails?.primary?.since?.year ? data.attributes?.roleDetails?.primary?.since?.year : '-'}}
            </div>
            <div class="search-detail__item search-detail__item_md3">
              {{data.attributes?.roleDetails?.primary?.to?.day ? data.attributes?.roleDetails?.primary?.to?.day : '-'}}/{{data.attributes?.roleDetails?.primary?.to?.month ?
                data.attributes?.roleDetails?.primary?.to?.month : '-'}}/{{data.attributes?.roleDetails?.primary?.to?.year ? data.attributes?.roleDetails?.primary?.to?.year : '-'}}
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- PREVIOUS ROLES -->
  <div class="search-detail__column" *ngIf="(recordType === 'INDIVIDUAL') && isShowSection.isShowPreviousRoles">
    <div class="search-detail__title">
      PREVIOUS ROLES
    </div>
    <div class="search-detail__text">
      <ng-container>
        <div class="search-detail__item-header search-detail__item_md3">
          Title
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          Category Type
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          From
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          To
        </div>
      </ng-container>
      <ng-container *ngFor="let data of dj3DetailData.searchResponse?.data">
        <ng-container *ngIf="data.attributes?.assetType === 'watchlist' ">
          <ng-container *ngFor="let previous of data.attributes?.roleDetails?.previous">
            <div class="search-detail__item search-detail__item_md3">
              {{previous?.title ? previous?.title : '-'}}
            </div>
            <div class="search-detail__item search-detail__item_md3">
              {{previous?.categoryType ? previous?.categoryType : '-'}}
            </div>
            <div class="search-detail__item search-detail__item_md3">
              {{previous?.since?.day ? previous?.since?.day : '-'}}/{{previous?.since?.month ? previous?.since?.month :
              '-'}}/{{previous?.since?.year ? previous?.since?.year : '-'}}
            </div>
            <div class="search-detail__item search-detail__item_md3">
              {{previous?.to?.day ? previous?.to?.day : '-'}}/{{previous?.to?.month ? previous?.to?.month :
              '-'}}/{{previous?.to?.year ? previous?.to?.year : '-'}}
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- OTHER ROLES -->
  <div class="search-detail__column" *ngIf="(recordType === 'INDIVIDUAL') && isShowSection.isShowOtherRoles">
    <div class="search-detail__title">
      OTHER ROLES
    </div>
    <div class="search-detail__text">
      <ng-container>
        <div class="search-detail__item-header search-detail__item_md3">
          Title
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          Category Type
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          From
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          To
        </div>
      </ng-container>
      <ng-container *ngFor="let data of dj3DetailData.searchResponse?.data">
        <ng-container *ngIf="data.attributes?.assetType === 'watchlist' ">
          <ng-container *ngFor="let other of data.attributes?.roleDetails?.other">
            <div class="search-detail__item search-detail__item_md3">
              {{other?.title ? other?.title : '-'}}
            </div>
            <div class="search-detail__item search-detail__item_md3">
              {{other?.categoryType ? other?.categoryType : '-'}}
            </div>
            <div class="search-detail__item search-detail__item_md3">
              {{other?.since?.day ? other?.since?.day : '-'}}/{{other?.since?.month ? other?.since?.month :
              '-'}}/{{other?.since?.year ? other?.since?.year : '-'}}
            </div>
            <div class="search-detail__item search-detail__item_md3">
              {{other?.to?.day ? other?.to?.day : '-'}}/{{other?.to?.month ? other?.to?.month :
              '-'}}/{{other?.to?.year ? other?.to?.year : '-'}}
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- KNOWN ASSOCIATE -->
  <div class="search-detail__column" *ngIf="isShowSection.isShowKnownAssociate">
    <div class="search-detail__title">
      KNOWN ASSOCIATE
    </div>
    <div class="search-detail__text">
      <ng-container>
        <div class="search-detail__item-header search-detail__item_md3">
          Name
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          Relationship
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          Active
        </div>
        <div class="search-detail__item-header search-detail__item_md3">
          Risks
        </div>
      </ng-container>
      <ng-container *ngFor="let data of dj3DetailData.searchResponse?.data">
        <ng-container *ngIf="data.attributes?.assetType === 'relationship' ">
          <ng-container *ngFor="let connectionDetail of data.attributes?.connectionDetails">
            <div class="search-detail__item search-detail__item_md3" *ngIf="connectionDetail">
              <span
                *ngIf="connectionDetail?.nameDetail?.firstName || connectionDetail?.nameDetail?.surname || connectionDetail?.nameDetail?.name; else emptyFullName">
                {{connectionDetail?.nameDetail?.firstName}} {{connectionDetail?.nameDetail?.middleName}} {{connectionDetail?.nameDetail?.surname}}
                {{connectionDetail?.nameDetail?.name}}
              </span>
              <ng-template #emptyFullName>
                <span>-</span>
              </ng-template>
            </div>
            <div class="search-detail__item search-detail__item_md3" *ngIf="connectionDetail">
              {{connectionDetail?.connectionType ?connectionDetail?.connectionType : '-' }}
            </div>
            <div class="search-detail__item search-detail__item_md3" *ngIf="connectionDetail">
              {{(connectionDetail?.isCurrent === true) ? 'Yes' : 'No'}}
            </div>
            <div class="search-detail__item search-detail__item_md3" *ngIf="connectionDetail">
              <ng-container>
                <span *ngFor="let risk of connectionDetail?.iconHints;  let i = index">
                  {{risk}}
                  <span *ngIf="i !== (connectionDetail?.iconHints.length - 1)">, </span>
                </span>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- ASSOCIATED ENTITY -->
  <div class="search-detail__column" *ngIf="(recordType === 'INDIVIDUAL') && isShowSection.isAssociatedEntity">
    <div class="search-detail__title">
      ASSOCIATED ENTITIES DETAILS
    </div>

    <!-- Associated Entities Details -->
    <ng-container *ngIf="isShowSection.isAssociatedEntities">
      <p class="search-detail__title search-detail__title--custom">Associated Entities</p>
      <div class="search-detail__text">
        <ng-container>
          <div class="search-detail__item-header search-detail__item_md6">
            Company Name
          </div>
          <div class="search-detail__item-header search-detail__item_md6">
            Company Code
          </div>
        </ng-container>
        <ng-container *ngFor="let data of dj3DetailData.searchResponse.data">
          <ng-container *ngIf="data.attributes.associatedEntityDetails?.associatedEntities">
            <ng-container *ngFor="let associatedEntity of data.attributes.associatedEntityDetails.associatedEntities">
              <div class="search-detail__item search-detail__item_md6">
                {{associatedEntity.companyName ? associatedEntity.companyName : '-'}}
              </div>
              <div class="search-detail__item search-detail__item_md6">
                {{ associatedEntity.companyFCode ? associatedEntity.companyFCode : '-' }}
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

    <!-- Reported Affected Entities -->
    <ng-container *ngIf="isShowSection.isReportedAffectedEntities">
      <p class="search-detail__title search-detail__title--custom">Reported Affected Entities</p>
      <div class="search-detail__text">
        <ng-container>
          <div class="search-detail__item-header search-detail__item_md6">
            Company Name
          </div>
          <div class="search-detail__item-header search-detail__item_md6">
            Company Code
          </div>
        </ng-container>
        <ng-container *ngFor="let data of dj3DetailData.searchResponse.data">
          <ng-container *ngIf="data.attributes.associatedEntityDetails?.reportedAffectedEntities">
            <ng-container *ngFor="let reportedAffectedEntity of data.attributes.associatedEntityDetails.reportedAffectedEntities">
              <div class="search-detail__item search-detail__item_md6">
                {{reportedAffectedEntity.companyName ? reportedAffectedEntity.companyName : '-'}}
              </div>
              <div class="search-detail__item search-detail__item_md6">
                {{ reportedAffectedEntity.companyFCode ? reportedAffectedEntity.companyFCode : '-' }}
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

    <!-- Reported Associated Entities -->
    <ng-container *ngIf="isShowSection.isReportedAssociatedEntities">
      <p class="search-detail__title search-detail__title--custom">Reported Associated Entities</p>
      <div class="search-detail__text">
        <ng-container>
          <div class="search-detail__item-header search-detail__item_md6">
            Company Name
          </div>
          <div class="search-detail__item-header search-detail__item_md6">
            Company Code
          </div>
        </ng-container>
        <ng-container *ngFor="let data of dj3DetailData.searchResponse.data">
          <ng-container *ngIf="data.attributes.associatedEntityDetails?.reportedAssociatedEntities">
            <ng-container *ngFor="let reportedAssociatedEntity of data.attributes.associatedEntityDetails.reportedAssociatedEntities">
              <div class="search-detail__item search-detail__item_md6">
                {{reportedAssociatedEntity.companyName ? reportedAssociatedEntity.companyName : '-'}}
              </div>
              <div class="search-detail__item search-detail__item_md6">
                {{ reportedAssociatedEntity.companyFCode ? reportedAssociatedEntity.companyFCode : '-' }}
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </div>

  <!-- IMAGE -->
  <div class="search-detail__column" *ngIf="isShowSection.isShowImage">
    <div class="search-detail__title">
      IMAGE
    </div>
    <div class="search-detail__text">
      <div class="search-detail__item">
        <div *ngFor="let data of dj3DetailData.searchResponse?.data">
          <div class="search-detail__item-text" *ngIf="data.attributes?.assetType === 'image' && data?.attributes">
            <p *ngFor="let imageDetail of data?.attributes?.imageDetails">
              <a class="search-detail__item-header link_underline" [href]="imageDetail?.externalUrl"
                target="_blank">{{imageDetail?.externalUrl}}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- SOURCE DETAILS -->
  <div class="search-detail__column" *ngIf="isShowSection.isShowSourceDetails">
    <div class="search-detail__title">
      SOURCE DETAILS
    </div>
    <div class="search-detail__text">
      <div class="search-detail__item">
        <div *ngFor="let data of dj3DetailData.searchResponse?.data">
          <div class="search-detail__item-text" *ngIf="data?.attributes">
            <p *ngFor="let source of data?.attributes?.sources">
              <a class="link search-detail__item-header link_underline" [href]="source?.externalLink" target="_blank"
                *ngIf="source?.externalLink">{{source?.externalLink}}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>